export default () => ({
  list: [],
  sharedDocument: {
    document: {}
  },
  unlockSharedDocument: false,
  types: [],
  document: [],
  comments: [],
  metaCommon: [],
  bulkUploadList: [],
  bulkUploadItem: {},
  draftDocuments: [],
  categories: [],
  draftDocumentItem: {},
  downloads:[],
  dashboardDocumentData: {
    list: [],
    list_me: [],
  },
})
